module.exports = __webpack_public_path__ + "img/567x600px-Iroda.2e88a9f4.jpg";